import React, {Component} from 'react';
import {connect} from 'react-redux';
import PageHeader from '../../components/PageHeader';
import {Link} from 'react-router-dom'
import validators from './validators';
import {guardarMaestro} from '../../utils/mantenimientoMaestro';
import {Redirect} from 'react-router'
import {displayValidationErrors, initializeValidators, isFormValid, resetValidators} from "../../utils/validateForm";

class MaestroNuevo extends Component {

    constructor(props) {
        super(props);
        this.state = {
            redirect: false,
            codGrupo: '',
            codTipo: '',
            descripcion: '',
            observacion: '',
            valorAdicional1: '',
            valorAdicional2: '',
            ordenPres: '',
            codGrupRec: '',
            codTipoRec: '',
            nombrePadre: '',
            indInactivo: 'N',
            isFormValided: false
        };
        this.validators = validators;
        resetValidators(this.validators);
    }

    componentDidMount() {

        if (this.props.location.state !== undefined) {
            const {codGrupo, codGrupoRec, codTipo, codTipoRec, descripcion, indInactivo, observacion, ordenPres, valorAdicional1, valorAdicional2, nombrePadre} = this.props.location.state.data;
            const child = this.props.location.state.child || false;

            this.setState({
                child: child ,
                codGrupo: child ? codGrupo : codGrupo || '',
                codGrupoRec: child ? codGrupo : codGrupoRec || '',
                codTipo: child ? '' : codTipo || '',
                codTipoRec: child ? codTipo : codTipoRec || '',
                descripcion: child ? '' : descripcion || '',
                indInactivo: child ? 'N' : indInactivo || 'N',
                observacion: child ? '' : observacion || '',
                ordenPres: child ? '' : ordenPres || '',
                valorAdicional1: child ? '' : valorAdicional1 || '',
                valorAdicional2: child ? '' : valorAdicional2 || '',
                nombrePadre: child ? descripcion : nombrePadre || ''
            });
            console.log("child <"+child+"> codGrupo <"+codGrupo+"> codTipo <"+codTipo+">");
            const datos={codGrupo:codGrupo,codTipo:codTipo,descripcion:descripcion};
            let promise = new Promise((resolve, reject) => {
                initializeValidators(this.validators,
                    datos,
                    true,
                    []);
                resolve();
            });
            promise.then(result => {
                this.onChangeFormValidation();
            });
        }

    }

    handleInputChange = (e, field, exclude) => {
        const validator = this.validators[field];
        if(validator){
            validator.state = (e !== null && !exclude ? e.target.value : '');
            validator.exclude = (typeof(exclude) === 'undefined' || exclude === null ? false : exclude);
        }
        this.onChangeFormValidation();
    }

    onChangeFormValidation = () => {
        this.setState({isFormValided: isFormValid(this.validators)});
    }
    onChangeValue = e => {
        if((e.target.validity.valid)){
            this.setState({ [e.target.name]: e.target.value });
            this.handleInputChange(e, [e.target.name]);
        }

    };

    guardarMaestro = () => {

        const {
            codGrupo, codGrupoRec, codTipo, codTipoRec, descripcion, indInactivo, observacion, ordenPres, valorAdicional1, valorAdicional2,isFormValided
        } = this.state;
        if (!isFormValided) {
            this.onChangeFormValidation();
            return;
        }


        guardarMaestro(codGrupo, codGrupoRec, codTipo, codTipoRec, descripcion, indInactivo, observacion, ordenPres, valorAdicional1, valorAdicional2)
            .then((response) => {
                console.log(response);
                if (response.data.estadoTrama === "1") {
                    this.setState({redirect:true});
                } else {
                    console.error("Error guardarMaestro")
                }
            });

    };

    onCheck = e => this.setState({[e.target.name]: e.target.checked});

    render() {
        const { redirect } = this.state;

        if (redirect) {
            return <Redirect to='/mantenimiento-maestros/ok'/>;
        }


        return (
            <div>
                <PageHeader title='Nuevo Maestro' buttonName='Nuevo Maestro' modalName='maestro-nuevo'/>
                <div className='wrapper'>
                    <div className='form-group' style={{marginTop: '20px'}}>
                        <div className='row'>
                            <div className='col-md-4'>
                                <label className='labelInfo' htmlFor='codGrupo'>Grupo</label>
                                <input pattern="[0-9]*" className='form-control' id='codGrupo' name='codGrupo' type='text'
                                         value={this.state.codGrupo} onChange={this.onChangeValue}/>
                                {displayValidationErrors(this.validators, 'codGrupo')}
                            </div>
                            <div className='col-md-4'>
                                <label className='labelInfo' htmlFor='ordenPres'>Orden</label>
                                <input className='form-control' id='ordenPres' name='ordenPres' type='text'
                                       value={this.state.ordenPres} onChange={this.onChangeValue}/>
                            </div>
                            <div className='col-md-4'>
                                <label className='labelInfo' htmlFor='codTipo'>Valor</label>
                                <input className='form-control' id='codTipo' name='codTipo' type='text'
                                       value={this.state.codTipo} onChange={this.onChangeValue}/>
                                {displayValidationErrors(this.validators, 'codTipo')}
                            </div>
                        </div>
                    </div>
                    <div className='form-group' style={{marginTop: '20px'}}>
                        <div className='row'>
                            <div className='col-md-4'>
                                <label className='labelInfo' htmlFor='valorAdicional1'>Valor Adicional 1</label>
                                <input className='form-control' id='valorAdicional1' name='valorAdicional1' type='text'
                                       value={this.state.valorAdicional1} onChange={this.onChangeValue}/>
                            </div>
                            <div className='col-md-4'>
                                <label className='labelInfo' htmlFor='valorAdicional2'>Valor Adicional 2</label>
                                <input className='form-control' id='valorAdicional2' name='valorAdicional2' type='text'
                                       value={this.state.valorAdicional2} onChange={this.onChangeValue}/>
                            </div>
                            <div className='col-md-4'>
                                <div className='checkbox' style={{marginTop: '20px'}}>
                                    <label htmlFor='indInactivo'>
                                        <input type='checkbox' id='indInactivo' name='indInactivo'
                                               checked={this.state.indInactivo === "S"} onChange={this.onCheck}/>
                                        <div className='checkbox-skin'/>
                                        Inactivo
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='form-group' style={{marginTop: '20px'}}>
                        <div className='row'>
                            <div className='col-md-12'>
                                <label className='labelInfo' htmlFor='descripcion'>Nombre</label>
                                <input className='form-control' id='descripcion' name='descripcion' type='text'
                                       value={this.state.descripcion} onChange={this.onChangeValue}/>
                                {displayValidationErrors(this.validators, 'descripcion')}
                            </div>
                        </div>
                    </div>
                    <div className='form-group' style={{marginTop: '20px'}}>
                        <div className='row'>
                            <div className='col-md-12'>
                                <label className='labelInfo' htmlFor='observacion'>Observación</label>
                                <textarea className="form-control" id='observacion' name='observacion'
                                          style={{'overflow': 'auto', 'resize': 'none', 'height': '100px'}}
                                          value={this.state.observacion} onChange={this.onChangeValue}/>
                            </div>
                        </div>
                    </div>
                    <div className='form-group' style={{marginTop: '20px'}}>
                        <div className='row'>
                            <div className='col-md-4'>
                                <label className='labelInfo' htmlFor='codGrupoRec'>Grupo Padre</label>
                                <input className='form-control' id='codGrupoRec' name='codGrupoRec' type='text'
                                       readOnly={true} value={this.state.codGrupoRec}/>
                            </div>
                            <div className='col-md-4'>
                                <label className='labelInfo' htmlFor='codTipoRec'>Valor Padre</label>
                                <input className='form-control' id='codTipoRec' name='codTipoRec' type='text'
                                       readOnly={true} value={this.state.codTipoRec}/>
                            </div>
                            <div className='col-md-4'>
                                <label className='labelInfo' htmlFor='nombrePadre'>Nombre Padre</label>
                                <input className='form-control' id='nombrePadre' name='nombrePadre' type='text'
                                       readOnly={true} value={this.state.nombrePadre}/>
                            </div>
                        </div>
                    </div>
                    <Link
                        className="btn btn-return"
                        role="button"
                        to={{pathname: '/mantenimiento-maestros'}}
                    >Cancelar</Link>
                    <button className='btn btn-primary pull-right' onClick={this.guardarMaestro}>Guardar</button>
                </div>
            </div>

        );
    }
}

function mapStateToProps(state) {
    return {};
}

MaestroNuevo.defaultProps = {};

export default connect(
    mapStateToProps,
    {}
)(MaestroNuevo);


// WEBPACK FOOTER //
// ./src/pages/MantMaestros/MaestroNuevo.js